export const FilterCountries = [
    { value: 901, label: 'Capital Federal' },
    { value: 902, label: 'Buenos Aires' },
    { value: 904, label: 'Córdoba' },
    { value: 921, label: 'Santa Fe' }
];

